/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Thai (Thailand)
export default {
  'embedded-confluence-common.src.content.empty-state-description':
    'เราค้นหาทุกที่แล้ว แต่ไม่พบรายการ หน้าข้อมูลอาจถูกลบออกไปแล้ว หรืออาจมีการพิมพ์ผิดใน URL 😉',
  'embedded-confluence-common.src.content.empty-state-header': 'เราไม่พบสิ่งที่คุณต้องการค้นหา',
  'embedded.confluence.already-logged-in-paragraph': 'เข้าสู่ระบบแล้วใช่ไหม ลองรีเฟรชหน้า',
  'embedded.confluence.footer.hover.text': 'ดูใน Confluence',
  'embedded.confluence.footer.prefix': 'สนับสนุนโดย',
  'embedded.confluence.generic-error-page.login-to-confluence-button': 'เข้าสู่ระบบ Confluence',
  'embedded.confluence.login-page.login-button': 'เข้าสู่ระบบ Confluence',
  'embedded.confluence.login-page.login-button.aria-label': 'ปุ่มเข้าสู่ระบบ',
  'embedded.confluence.login-page.login-text': 'คุณจำเป็นต้องเข้าสู่ระบบเพื่อดูหน้านี้',
  'embedded.confluence.login-page.refresh-page-banner':
    'หลังจากเข้าสู่ระบบแล้ว หน้าข้อมูลนี้ควรรีเฟรชโดยอัตโนมัติ หากไม่มีการรีเฟรชโดยอัตโนมัติ คุณสามารถคลิกที่นี่เพื่อรีเฟรช',
  'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'รีเฟรชหน้าข้อมูล',
  'embedded.confluence.need-to-log-in-paragraph': 'คุณจำเป็นต้องเข้าสู่ระบบเพื่อดูหน้านี้',
  'embedded.confluence.still-having-trouble-paragraph':
    'ยังคงมีปัญหาใช่ไหม ตรวจสอบให้แน่ใจว่ามีการเปิดใช้งานคุกกี้ของบุคคลที่สามอยู่ หรือ {link}',
  'embedded.confluence.troubleshooting-link-text': 'ดูที่คู่มือการแก้ไขปัญหานี้',
  'embedded.confluence.troubleshooting-link.aria-label': 'ลิงก์คู่มือการแก้ไขปัญหา',
};
